"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accordion_1 = require("../modules/accordion");
var get_element_1 = require("../utils/get_element");
var IDS = {
    CONTAINER: 'js-questions-container',
};
var questionsDetailsContainer = (0, get_element_1.getElementById)(IDS.CONTAINER);
new accordion_1.Accordion(questionsDetailsContainer);
